export default "__VITE_ASSET__Br9BS$lc__"